import { Box, StepIconProps, useTheme } from '@mui/material';

const StepIconComponent = (props: StepIconProps) => {
    const { icon, active, completed } = props;
    const theme = useTheme();

    const getStepColor = (isActiveOrCompleted: boolean) => {
        if (isActiveOrCompleted) {
            return '#FF5722'; 
        } else {
            return theme.palette.mode === 'dark' ? '#7B341E' : '#FFD0B5'; 
        }
    };
    
    const stepNumber = Number(icon);
    const isActiveOrCompleted = active || completed;
    const backgroundColor = getStepColor(isActiveOrCompleted);
    
    return (
        <Box sx={{ position: 'relative' }}>
            {/* Circle indicator */}
            <Box
                sx={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    backgroundColor: backgroundColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: 'bold',
                    zIndex: 1,
                }}
            >
                {icon}
            </Box>
            
            {/* Vertical line below the circle */}
            <Box
                sx={{
                    position: 'absolute',
                    left: '15px',
                    top: '38px',
                    width: '2px',
                    height: '30px',
                    backgroundColor: 'rgba(128, 128, 128, 0.4)',
                    zIndex: 0,
                }}
            />
        </Box>
    );
};

export default StepIconComponent;
